// extracted by mini-css-extract-plugin
module.exports = {"section":"BackToSearch_section__64RB9","fixed":"BackToSearch_fixed__m5ItL","back":"BackToSearch_back__14ghm","arrow":"BackToSearch_arrow__2A1ix"};